/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useMemo, useContext, createContext } from 'react'
import { useGLTF, Merged } from '@react-three/drei'

const context = createContext()
export function DslSatInstances({ children, ...props }) {
  const { nodes } = useGLTF('/models/Satellite_Generic.glb')
  const instances = useMemo(
    () => ({
      SolarPanel: nodes.Solar_Panel_01,
      SolarPanel1: nodes.Solar_Panel_02,
    }),
    [nodes]
  )
  return (
    <Merged castShadow receiveShadow meshes={instances} {...props}>
      {(instances) => <context.Provider value={instances} children={children} />}
    </Merged>
  )
}

export function DslSat(props) {
  const instances = useContext(context)
  const { nodes, materials } = useGLTF('/models/Satellite_Generic.glb')
  return (
    <group {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Body"
          castShadow
          receiveShadow
          geometry={nodes.Body.geometry}
          material={materials['EO-Sat_v2']}
          rotation={[0, 0.262, 0]}>
          <instances.SolarPanel name="Solar_Panel_01" />
          <instances.SolarPanel1 name="Solar_Panel_02" />
          <instances.SolarPanel1 name="Solar_Panel_03" position={[0, 0, 1.021]} />
          <instances.SolarPanel1 name="Solar_Panel_04" position={[0, 0, 2.042]} />
          <instances.SolarPanel1 name="Solar_Panel_05" position={[0, 0, 3.063]} />
          <instances.SolarPanel
            name="Solar_Panel_A"
            position={[0, 1.5, 0]}
            rotation={[Math.PI, 0, 0]}
          />
          <instances.SolarPanel1
            name="Solar_Panel_B"
            position={[0, 1.5, 0]}
            rotation={[Math.PI, 0, 0]}
          />
          <instances.SolarPanel1
            name="Solar_Panel_C"
            position={[0, 1.5, -1.021]}
            rotation={[Math.PI, 0, 0]}
          />
          <instances.SolarPanel1
            name="Solar_Panel_D"
            position={[0, 1.5, -2.042]}
            rotation={[Math.PI, 0, 0]}
          />
          <instances.SolarPanel1
            name="Solar_Panel_E"
            position={[0, 1.5, -3.063]}
            rotation={[Math.PI, 0, 0]}
          />
          <mesh
            name="Thrusters"
            castShadow
            receiveShadow
            geometry={nodes.Thrusters.geometry}
            material={materials['EO-Sat_v2']}
          />
        </mesh>
      </group>
    </group>
  )
}

useGLTF.preload('/models/Satellite_Generic.glb')
